import { Poppins, Quicksand } from 'next/font/google'
import Image from 'next/image'
import React from 'react'
const popins =Poppins({weight:"500",subsets:['latin']})
const extrapopins =Poppins({weight:"400",subsets:['latin']})
const quickSand =Quicksand({weight:"400",subsets:['latin']})
export default function Coursereview(props) {
    
  return (
    <>
<section id='S4' className='mb20'>
<div className='container'>

<div className="df fjc fac fjse pdt50 mpdt30">
            <div className="top-cate df fac fjsa">
              <Image
                className="img"
                src={"/home/round-img.webp"}
                alt="Circle-Img"
                width={"20"}
                height={"20"}
                loading="lazy"
              />
              <h4 className={`fs-33 mfs-20 ${popins.className}`}>Testimonials</h4>
              <Image
                className="img"
                src={"/home/round-img.webp"}
                alt="Circle-Img"
                width={"20"}
                height={"20"}
                loading="lazy"
              />
            </div>
          </div>
    <h3 className={`fs-32 mfs-19 tac ylw-clr mt16 mmt10 ${popins.className}`}>What our happy student says</h3>
    
<div className='mt40 mmt16'>
<div className='df mfdc gap20 mfac'>
    <div className='rating-box-1 df fdc fac fjc'>
       <div>
        <h4 className={`fs-28 mfs-24 tac`}>4.9</h4>
        <div className='rad-box df fjse mt36'>
         <div><Image src={"/course-img/course-review/rating-star.webp"} alt='Rating-Star-Icon' width={"24"} height={"24"}   loading='lazy'/></div>
         <div><Image src={"/course-img/course-review/rating-star.webp"} alt='Rating-Star-Icon' width={"24"} height={"24"}   loading='lazy'/></div>
         <div><Image src={"/course-img/course-review/rating-star.webp"} alt='Rating-Star-Icon' width={"24"} height={"24"}   loading='lazy'/></div>
         <div><Image src={"/course-img/course-review/rating-star.webp"} alt='Rating-Star-Icon' width={"24"} height={"24"}   loading='lazy'/></div>
         <div><Image src={"/course-img/course-review/rating-star.webp"} alt='Rating-Star-Icon' width={"24"} height={"24"}   loading='lazy'/></div>
        </div>
        <p className={`fs-14 tac mt12 ${quickSand.className}`}>345 Rating</p>
       </div>
    </div>
<div className='scorecard-box df fdc fac fjc fjse'>
<div className='df gap10 fac'>
    <p className={`fs-14 mfs-10 ${quickSand.className}`}>5 Stars</p>
    <div className="bar-container df ">
      <div className="bar-5"></div>
    </div>
    <p className={`fs-14 mfs-10 ${quickSand.className}`}>99%</p>
</div>

<div className='df fac gap10'>
    <p className={`fs-14 mfs-10 ${quickSand.className}`}>4 Stars</p>
    <div className="bar-container">
      <div className="bar-4"></div>
    </div>
    <p className={`fs-14 mfs-10 ${quickSand.className}`}>01%</p>
</div>

<div className='df fac gap10'>
    <p className={`fs-14 mfs-10 ${quickSand.className}`}>3 Stars</p>
    <div className="bar-container">
      <div className="bar-3"></div>
    </div>
    <p className={`fs-14 mfs-10 ${quickSand.className}`}>00%</p>
</div>

<div className='df fac gap10'>
    <p className={`fs-14 mfs-10 ${quickSand.className}`}>2 Stars</p>
    <div className="bar-container">
      <div className="bar-2"></div>
    </div>
    <p className={`fs-14 mfs-10 ${quickSand.className}`}>00%</p>
</div>

<div className='df fac gap10'>
    <p className={`fs-14 mfs-10 ${quickSand.className}`}>1 Stars</p>
    <div className="bar-container">
      <div className="bar-1"></div>
    </div>
    <p className={`fs-14 mfs-10 ${quickSand.className}`}>00%</p>
</div>

</div>
</div>
{props.ReviewData.map((items,index)=>{
    return(

<div key={index} className='mdf mfjc'>

<div className='review-box mt20 mmt12 df ' >

<div className='df fac fjc mfdc mfafs'>
    <div className='mdn pdl20'>
        <Image src={items.img} alt='User-img' width={"96"} height={"119"} loading='lazy'/>
    </div>
    <div className='dn mdb pdl20 mpdt10'>
        <Image src={items.img} alt='User-img' width={"56"} height={"69"} loading='lazy'/>
    </div>
    <div className='ml24 mml15'>
    <div className='rad-box-1'>
        <div className='mt10 mmt5 df fac fjse'>
         <div><Image src={"/course-img/course-review/rating-star.webp"} alt='Rating-Star-Icon' width={"12"} height={"12"}   loading='lazy'/></div>
         <div><Image src={"/course-img/course-review/rating-star.webp"} alt='Rating-Star-Icon' width={"12"} height={"12"}   loading='lazy'/></div>
         <div><Image src={"/course-img/course-review/rating-star.webp"} alt='Rating-Star-Icon' width={"12"} height={"12"}   loading='lazy'/></div>
         <div><Image src={"/course-img/course-review/rating-star.webp"} alt='Rating-Star-Icon' width={"12"} height={"12"}   loading='lazy'/></div>
         <div><Image src={"/course-img/course-review/rating-star.webp"} alt='Rating-Star-Icon' width={"12"} height={"12"}   loading='lazy'/></div>
         </div>
        </div>
        <p className={`fs-16 mfs-14 mt10 ${quickSand.className}`}>{items.Username} <span className='fs-12 dim-clr'>{items.date}</span></p> 
        <p className='fs-14 mfs12 mt4 mb29 mmb5 mpdl'>{items.review}</p>
        </div>
</div>

</div>
</div>

)
})}
</div>


</div>
</section>

<style jsx>
    {`
    .scorecard-box{
width: 425px;
height:295px;
border: 1px solid #D3D3D3;
border-radius: 8px;

    }
    .bar-container {
        width: 250px;
        background-color: #f1f1f1;
        text-align: center;
        color: white;
        border-radius: 50px;
        height: 12px;
       
      }
      
   
.bar-5 {
    width: 99%; height: 12px; border-radius:50px; background-color: #FFD700;
}
.bar-4 {
    width: 1%; height: 12px; border-radius:50px; background-color: #FFD700;
}
.bar-3 {
    width: 0%; height: 12px; border-radius:50px; background-color: #FFD700;
}
.bar-2 {
    width: 0%; height: 12px; border-radius:50px; background-color: #FFD700;
}
.bar-1 {
    width: 0%; height: 12px; border-radius:50px; background-color: #FFD700;
}

    .review-box{
        width: 720px;
        height:100%;
        padding: 10px;
        border-radius: 8px;
        border: 1px solid #D3D3D3;
        background-color: #FFFFFF;

    }
    .rad-box{
      width: 168px;
      height: 32px;
      border-radius: 24px;
      background-color: #F1F1F1;  
    }
    .top-cate {
        background-color: #ffffff;
        width: 300px;
        height: 70px;
        border: 1px solid #fdbb39;
        border-radius: 46px;
        box-shadow: 0 8px 46px 0 rgba(253, 187, 57, 0.3);
    }
    .rad-box-1{
      width: 90px;
      height: 20px;
      border-radius: 24px;
      background-color: #F1F1F1; 
      padding: 0px 4px;
    }
    .rating-box-1{
        width:295px;
        height:295px;
        border: 1px solid #D3D3D3;
    }
    
    @media only screen and (max-width: 1023px){
        .review-box{
            width: 100%;
            height:100%;
            border-radius: 4px;
            border: 1px solid #D3D3D3;
            background-color: #FFFFFF;
    
        }
        .top-cate {
            background-color: #ffffff;
            width: 200px;
            height: 55px;
            border: 1px solid #fdbb39;
            border-radius: 46px;
            box-shadow: 0 8px 46px 0 rgba(253, 187, 57, 0.3);
        }
        .rating-box-1{
   
            width:100%;
            height:238px;
    
        }
        .scorecard-box{
            width: 100%;
            height:238px;
            border: 1px solid #D3D3D3;
            border-radius: 8px;
            
            
                }

                        .bar-container {
                            width: 150px;
                            background-color: #f1f1f1;
                            text-align: center;
                            color: white;
                            border-radius: 25px;
                            height: 6px;
                           
                          }
                          
                       
                    .bar-5 {
                        width: 99%; height: 6px; border-radius:25px; background-color: #FFD700;
                    }
                    .bar-4 {
                        width: 1%; height: 6px; border-radius:25px; background-color: #FFD700;
                    }
                    .bar-3 {
                        width: 0%; height: 6px; border-radius:25px; background-color: #FFD700;
                    }
                    .bar-2 {
                        width: 0%; height: 6px; border-radius:25px; background-color: #FFD700;
                    }
                    .bar-1 {
                        width: 0%; height: 6px; border-radius:25px; background-color: #FFD700;
                    }

    }
    
    `}
</style>

</>
  )
}
